import { useTranslation } from "react-i18next";
import { useState, useEffect } from 'react';


const LanguageLanding = (props) => {
     const [language, setLanguage] = useState();
    const { t, i18n } = useTranslation()


    useEffect(() => {
        const storedLanguage = localStorage.getItem('language');
        if (storedLanguage) {
            setLanguage(storedLanguage);
            i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);

    const handleLanguageChange = (event) => {
        const selectedLanguage = event.target.value;
        setLanguage(selectedLanguage);
        localStorage.setItem('language', selectedLanguage);
        // localStorage.setItem("i18nextLng",selectedLanguage );

        i18n.changeLanguage(selectedLanguage);
        window.location.reload()
    }
    const storedLanguage = localStorage.getItem('language');


    return (
        <div className="lang-outerr langg" style={{}} >
            <img style={{
                marginBottom:'3px'
            }} src="../images/Globe-2.png" />
            <select onChange={handleLanguageChange} style={{ border: 'none', background: '#007bff', color: 'white' }} defaultValue={storedLanguage} >
                <option value={'en'}>{('English')}</option>
                <option value={'fi'}>{('Finnish')}</option>
                <option value={'es'}>{('Estonian')}</option>

            </select>
        </div>
    )
}
export default LanguageLanding;




